module.exports = __webpack_public_path__ + "img/312.99378a47.png";